var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPlus = function SvgPlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 11.3333H12.6668V3.99992C12.6668 3.82311 12.5965 3.65354 12.4715 3.52851C12.3465 3.40349 12.1769 3.33325 12.0001 3.33325C11.8233 3.33325 11.6537 3.40349 11.5287 3.52851C11.4037 3.65354 11.3334 3.82311 11.3334 3.99992V11.3333H4.00011C3.8233 11.3333 3.65373 11.4035 3.52871 11.5285C3.40368 11.6535 3.33344 11.8231 3.33344 11.9999C3.33015 12.0866 3.34548 12.1729 3.37837 12.2531C3.41127 12.3333 3.46099 12.4056 3.52416 12.465C3.58734 12.5244 3.66251 12.5695 3.74461 12.5974C3.82671 12.6253 3.91384 12.6352 4.00011 12.6266H11.3334V19.9999C11.3334 20.1767 11.4037 20.3463 11.5287 20.4713C11.6537 20.5963 11.8233 20.6666 12.0001 20.6666C12.1769 20.6666 12.3465 20.5963 12.4715 20.4713C12.5965 20.3463 12.6668 20.1767 12.6668 19.9999V12.6666H20.0001C20.1769 12.6666 20.3465 12.5963 20.4715 12.4713C20.5965 12.3463 20.6668 12.1767 20.6668 11.9999C20.6668 11.8231 20.5965 11.6535 20.4715 11.5285C20.3465 11.4035 20.1769 11.3333 20.0001 11.3333Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plus.df5f03c2.svg";
export { ForwardRef as ReactComponent };